import React from "react";
import { useTranslation } from "react-i18next";
import { useAuthentication } from "@planzone/view-models";

import { Loader } from "@common/loader";
import { Props } from "./types";
import styles from "./styles.scss";

function LogIn(_: Props) {
  const { t } = useTranslation();
  const { isRequestPending, authenticate, hasSession } = useAuthentication();

  React.useEffect(() => {
    authenticate({ code: "" });
  }, []);

  return (
    <div className={styles.logIn}>
      {isRequestPending && (
        <div className={styles.loader}>
          <div className={styles.loaderMain}>
            <Loader />
          </div>
        </div>
      )}
      <div className={styles.heading}>
        <h1 className={styles.title}>{t("logIn.title")}</h1>
        <h2 className={styles.subTitle}>{t("logIn.subTitle")}</h2>
      </div>
      <div
        className={styles.buttonBox}
        onClick={() => !hasSession && authenticate({ code: "" })}
      >
        <button
          disabled={hasSession || isRequestPending}
          className={styles.button}
        >
          {t("logIn.authenticate")}
        </button>
      </div>
    </div>
  );
}

export { LogIn };
